export const priceCurrency = (tier, currency) => {
  switch (currency) {
    case 'USD':
      return tier.usdPrice;
    case 'EUR':
      return tier.eurPrice;
    default:
      return tier.eurPrice;
  }
};

export const symbolCurrency = (currency) => {
  switch (currency) {
    case 'USD':
      return '$';
    case 'EUR':
      return '€';
    default:
      return '€';
  }
};
